// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  client_secret: "auth.testing",
  client_id: "auth.testing",



  //----Desarrollo---- WEB: https://dimme-dev.megacable.com.mx/
  // api_url: 'https://api-dimme-dev.megacable.com.mx',
  // socket_url: 'https://api-dimme-dev.megacable.com.mx/refreshsocket',
  // oauth_server: 'https://api-dimme-dev.megacable.com.mx/auth/oauth/token',
  // key_Maps: 'AIzaSyCB4gXS1-1_oCM8K_27Eb90g7zgWCicPK0',
  // MEGA_API_URL: 'https://189.199.79.234:9004/mega/api',
  // API_MEGA: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // API_MEGA_2: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // API_SFYC: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // MEGA_API_URL2: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // MEGA_API_URL_VENTAS: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // Mega_url: 'https://dimmepruebas.megacable.com.mx:9004/mega/api',
  // //SI CAMBIA, ACTUALIZAR SCRIPT EN EL INDEX HTML
  // recaptchaSiteKey: '6Le1YGEpAAAAAOTX-LLuHOwBxx2lfRraFVpcO9Zi',
  // URL_IMAGES_LOCAL: 'https://dimme-dev.megacable.com.mx',
  // BASIC_AUTH_CREDENTIALS:'asigno:asigno',
  GEOMEGA_MAP_FAILURE_POINT: 'https://geomega.com.mx/rnoc/demo.php',
  RNOC_MAP_FAILURE_POINT: 'https://rnoc.geomega.com.mx',
  
  //----Servicio externo de geocercas----
  GEOMEGA_GEOFENCE_URL: 'https://servicios.geomega.com.mx/ws4/geocerca',
  GEOMEGA_GEOFENCE_TOKEN: 'F0F2EA66FC36B559A47FE7F27885A2B6',
  // GEOMEGA_MAPA_RNOC:'https://rnoc.geomega.com.mx/dimme/demo.php',
  GEOMEGA_MAPA_RNOC:'https://rnoc.geomega.com.mx/dimme/',
  

 //----Producción---- WEB: https://dimme.megacable.com.mx/

  api_url: 'https://apiweb-dimme.megacable.com.mx',
  socket_url: 'https://apiweb-dimme.megacable.com.mx/refreshsocket',
  oauth_server: 'https://apiweb-dimme.megacable.com.mx/auth/oauth/token',
  key_Maps: 'AIzaSyBExXrFjXNJqDA_JhR7dxB5VkqMUqE_3yY',
  MEGA_API_URL: 'https://dimme.megacable.com.mx/mca/api',
  API_MEGA: 'https://dimme.megacable.com.mx:9003/mega/api',
  API_MEGA_2: 'https://dimme.megacable.com.mx:9003/mega/api',
  API_SFYC: 'https://dimme.megacable.com.mx:9003/mega/api',
  MEGA_API_URL_VENTAS: 'https://dimme.megacable.com.mx:9003/mega/api',
  Mega_url: 'https://dimme.megacable.com.mx:9003/mega/api',
  MEGA_API_URL2: 'https://dimme.megacable.com.mx:9003/mega/api',
  //SI CAMBIA, ACTUALIZAR SCRIPT EN EL INDEX HTML
  recaptchaSiteKey: '6Le1YGEpAAAAAOTX-LLuHOwBxx2lfRraFVpcO9Zi',
  URL_IMAGES_LOCAL: 'https://dimme.megacable.com.mx',
  BASIC_AUTH_CREDENTIALS:'asigno:Mega2023.*'
};

export const  {version:appVersion} = require("../../package.json");
export const  {name:applicationName} = require("../../package.json");
export const  versionType = {versionType:"SNAPSHOT"};
export const  {compilationDate:compilationDate} = require("../../package.json");
